exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn.adding-product[data-v-40497d0d]{opacity:.5;cursor:default}", ""]);

// exports
